import { render, staticRenderFns } from "./specs.vue?vue&type=template&id=4d40a2cf&scoped=true&"
import script from "./specs.vue?vue&type=script&lang=js&"
export * from "./specs.vue?vue&type=script&lang=js&"
import style0 from "./specs.vue?vue&type=style&index=0&id=4d40a2cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40a2cf",
  null
  
)

export default component.exports